
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advertising",
      function () {
        return require("private-next-pages/advertising.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advertising"])
      });
    }
  